import { useRequestGetPaymentMethodRequests } from '@/hooks/httpRequest/paymentMethodRequests';
import useUrlParams from './useUrlParams';

export const usePaymentMethodRequests = () => {

  const { sortType, sortBy, limit, page, status, country } = useUrlParams();
  const result = useRequestGetPaymentMethodRequests({
    sortType,
    sortBy,
    status,
    country,
    limit,
    page
  });

  return ({
    ...result
  });

};
